/**
 * Escape a JSON-LD string so it cannot close the surrounding script tag.
 * The escapes are valid JSON, so the parsed data is unchanged.
 * @param {string} json - Serialized JSON-LD
 * @returns {string}
 */
export function escapeJsonLd(json) {
  return String(json)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026');
}

/**
 * Build the robots meta content from the Yoast seo object.
 * Mirrors the directives Yoast prints on a classic WordPress page.
 * @param {Object} seo - Yoast seo object from WPGraphQL
 * @returns {string}
 */
export function robotsContent(seo) {
  const index = seo?.metaRobotsNoindex === 'noindex' ? 'noindex' : 'index';
  const follow = seo?.metaRobotsNofollow === 'nofollow' ? 'nofollow' : 'follow';

  if (index === 'noindex') {
    return `${index}, ${follow}`;
  }

  return `${index}, ${follow}, max-snippet:-1, max-image-preview:large, max-video-preview:-1`;
}

/**
 * Canonical for paginated listing pages. Page 1 has no query string,
 * from page 2 onward the page number stays, all other query params are dropped.
 * @param {string} baseUrl - Public site URL
 * @param {string} path - Route path
 * @param {string|number|undefined} page - Value of the page query param
 * @returns {string}
 */
export function listingCanonical(baseUrl, path, page) {
  const normalizedPath = path.endsWith('/') ? path : `${path}/`;
  const pageNumber = parseInt(page, 10);
  const query = pageNumber > 1 ? `?page=${pageNumber}` : '';

  return `${baseUrl}${normalizedPath}${query}`;
}
